import { useMemo } from 'react';
import { Role } from '../../types';
import { useGetAccessTokenPayload } from './useGetAccessTokenPayload';

const rolePrioritySr: Role[] = [
  Role.SR_ISSUER_ADMIN,
  Role.SR_ISSUER,
  Role.SR_INVESTOR,
  Role.SR_ADMIN,
  Role.COMPLIANCE_ADMIN,
  Role.COMPLIANCE_USER,
  Role.LOANS_ADMIN,
  Role.LOANS_USER,
  Role.ACADEMY_USER,
  Role.ACADEMY_ORGANISATION_ADMIN,
];

const rolePriorityCompliance: Role[] = [
  Role.COMPLIANCE_ADMIN,
  Role.COMPLIANCE_USER,
  Role.SR_ADMIN,
  Role.SR_ISSUER_ADMIN,
  Role.SR_ISSUER,
  Role.SR_INVESTOR,
  Role.LOANS_ADMIN,
  Role.LOANS_USER,
  Role.ACADEMY_USER,
  Role.ACADEMY_ORGANISATION_ADMIN,
];

const rolePriorityAppSelector: Role[] = [
  Role.SR_ISSUER_ADMIN,
  Role.SR_ISSUER,
  Role.SR_INVESTOR,
  Role.SR_ADMIN,
  Role.COMPLIANCE_ADMIN,
  Role.COMPLIANCE_USER,
  Role.LOANS_ADMIN,
  Role.LOANS_USER,
  Role.ACADEMY_USER,
  Role.ACADEMY_ORGANISATION_ADMIN,
];

export type Site = 'sr' | 'compliance' | 'app-selector';

export const useGetUserRoles = (site: Site = 'app-selector'): Role[] => {
  const tokenPayload = useGetAccessTokenPayload();
  return useMemo<Role[]>(() => {
    const organizationsRoles: Role[] = Array.from(
      new Set(
        Object.values(tokenPayload?.organization_roles || {}).flatMap(
          (org: any) => org?.roles || [],
        ),
      ),
    );

    const realm_roles: Role[] = (tokenPayload?.realm_access?.roles || []).filter(
      (r: string) =>
        Object.values(Role).includes(r as Role) &&
        (!organizationsRoles.includes(Role.ACADEMY_ORGANISATION_ADMIN) ||
          ![Role.ACADEMY_USER, Role.ACADEMY_ORGANISATION_ADMIN].includes(r as Role)),
    );

    const roles: Role[] = Array.from(new Set([...realm_roles, ...organizationsRoles])).filter(r =>
      Object.values(Role).includes(r as Role),
    );

    if (site === 'sr') {
      const sortedRole = roles.sort(
        (a, b) => rolePrioritySr.indexOf(a as Role) - rolePrioritySr.indexOf(b as Role),
      );
      // console.log('Sorted role SR:', sortedRole);
      return sortedRole;
    }

    if (site === 'compliance') {
      const sortedRole = roles.sort(
        (a, b) =>
          rolePriorityCompliance.indexOf(a as Role) - rolePriorityCompliance.indexOf(b as Role),
      );
      // console.log('Sorted role Compliance:', sortedRole);
      return sortedRole;
    }
    const sortedRole = roles.sort(
      (a, b) =>
        rolePriorityAppSelector.indexOf(a as Role) - rolePriorityAppSelector.indexOf(b as Role),
    );
    // console.log('Sorted role AppSelector:', sortedRole);
    return sortedRole;
  }, [site, tokenPayload?.organization_roles, tokenPayload?.realm_access?.roles]);
};
